import { render, staticRenderFns } from "./BackgroundVideoPlayer.vue?vue&type=template&id=3cbb4a20&scoped=true"
import script from "./BackgroundVideoPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundVideoPlayer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BackgroundVideoPlayer.vue?vue&type=style&index=0&id=3cbb4a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbb4a20",
  null
  
)

export default component.exports